// extracted by mini-css-extract-plugin
export default {"columns":"Votings_columns__d+v9f","circleStatus":"Votings_circleStatus__VNeFS","circleAndStatus":"Votings_circleAndStatus__9Jydx","statusText":"Votings_statusText__iDtpT"};